import Parse from "parse"

// Falls back to statusHistory since some Delivery records (seeded before the
// status-update feature existed) only carry a flat "status" field
const getDeliveryStatus = (delivery) => {
  const status = delivery.get("status")
  if (status) return status

  const statusHistory = delivery.get("statusHistory") || []
  return statusHistory.length ? statusHistory[statusHistory.length - 1].status : "DRAFT"
}

export const hasOngoingDeliveriesForEnterprise = async (enterpriseId) => {
  const enterprise = new Parse.Object("Enterprises")
  enterprise.id = enterpriseId

  const deliveries = await new Parse.Query("Delivery")
    .equalTo("enterprise", enterprise)
    .select("status", "statusHistory")
    .find()

  return deliveries.some((delivery) => getDeliveryStatus(delivery) !== "DRAFT")
}

export const hasPlanningRulesForEnterprise = async (enterpriseId) => {
  const enterprise = new Parse.Object("Enterprises")
  enterprise.id = enterpriseId

  const inAutoSaveable = new Parse.Query("PlanningRules")
    .equalTo("autoSaveableTargets.targetEnterprise", enterprise)

  const inVolumeReporting = new Parse.Query("PlanningRules")
    .equalTo("volumeReportingTargets.targetEnterprise", enterprise)

  const count = await Parse.Query.or(inAutoSaveable, inVolumeReporting).count()
  return count > 0
}